(() => {
  document.querySelectorAll('[data-ax-page]').forEach((root) => {
    root.querySelectorAll('.ax-faq details').forEach((item) => {
      item.addEventListener('toggle', () => {
        const icon = item.querySelector('summary span');
        if (icon) icon.textContent = item.open ? '−' : '+';
        if (item.open) {
          root.querySelectorAll('.ax-faq details[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });
        }
      });
    });

    const video = root.querySelector('.ax-video video');
    if (video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.play().catch(() => {});
    }
  });
})();
